import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RegistrationPageRoutingModule } from './registration-routing.module';

import { RegistrationPage } from './registration.page';
import {IntlTelInputNgModule} from "intl-tel-input-ng";
import {TranslocoDirective, TranslocoPipe} from "@jsverse/transloco";
import {HomePageModule} from "../home/home.module";
import {SharedModule} from "../../shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RegistrationPageRoutingModule,
    IntlTelInputNgModule,
    NgOptimizedImage,
    TranslocoDirective,
    TranslocoPipe,
    FormsModule,
    ReactiveFormsModule,
    SharedModule

  ],
  declarations: [RegistrationPage]
})
export class RegistrationPageModule {}
